import { AxiosError } from "axios";
import { BoardModel } from "models/BoardModel";
import { createContext } from "react";

export interface IBoardContext {
  boardId: string | undefined;
  board: BoardModel | undefined;
  error?: AxiosError;
  isLoading: boolean;
  reloadBoard: () => Promise<void>;
}

export const BoardContext = createContext({} as IBoardContext);
